
/***
 * Son els tipñus de solucions amb les que treballem
 */
export enum OperatingSystems {
    ios = "ios",
    android = "android",
    browser = "browser"
}